import './ccf-accordion-details.module.scss';
import { AccordionDetails, AccordionDetailsProps } from '@mui/material';


/**
 * CcfAccordionDetails used to display react accordion details
 * @example <CcfAccordionDetails />
 */
export function CcfAccordionDetails({children, ...rest}: AccordionDetailsProps) {
  return <AccordionDetails {...rest} >{children}</AccordionDetails>
}

export default CcfAccordionDetails;
